// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202603021103/js/" + chunkId + "." + {"44":"d29eabd8","225":"5d5eff6a","481":"4782f6a7","486":"6c8b7838","770":"d1200622"}[chunkId] + ".0.15597766872686014.chunk.js";
};